import { render } from "./CampaignUpdate.vue?vue&type=template&id=5879db16&scoped=true"
import script from "./CampaignUpdate.vue?vue&type=script&lang=js"
export * from "./CampaignUpdate.vue?vue&type=script&lang=js"

import "./CampaignUpdate.vue?vue&type=style&index=0&id=5879db16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5879db16"]])

export default __exports__